import React from "react";
import createAnalysisChart from "./CreateAnalysisChart";
import { STAGE_COLOR_MAP } from "../../../lib/constants";
import { AnalysisChartProps } from "./types";

const PhaseAnalysisChart = createAnalysisChart({
  chartType: "phase",
  title: "Phase Analysis",
  legendTitle: "Phases",
  categoryField: "Phase",
  colorMap: STAGE_COLOR_MAP,
  volumeLabel: "Invested capital",
  countLabel: "Number of Deals",
}) as React.ComponentType<AnalysisChartProps>;

export default PhaseAnalysisChart;
